import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class FleetService {
  getVehicleActivity(date, page = 1) {
    return axios
      .get(`${config.apiUrl.replace(/\/+$/, "")}/fleet/vehicles/activity`, {
        headers: authHeader(),
        params: { date, page },
      })
      .then((response) => response.data);
  }

  listAvailableVehicles(date) {
    return axios.get(`${config.apiUrl.replace(/\/+$/, "")}/fleet/vehicles/available`, {
      headers: authHeader(), params: { date },
    }).then((response) => response.data);
  }

  reserveVehicle(vehicleId, date) {
    return axios.post(`${config.apiUrl.replace(/\/+$/, "")}/fleet/vehicles/${vehicleId}/reserve`, { date }, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  reserveRental(data) {
    return axios.post(`${config.apiUrl.replace(/\/+$/, "")}/fleet/vehicles/rental`, data, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  endVehicleReserve(vehicleId, reservationId) {
    return axios.patch(`${config.apiUrl.replace(/\/+$/, "")}/fleet/vehicles/${vehicleId}/reservations/${reservationId}/end`, {}, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getFuel() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/fuel`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getOffices() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/offices`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getAcquisitionTypes() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/acquisitionTypes`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInsuranceTypes() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/insuranceTypes`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInsuranceDuration() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/insuranceDuration`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getVehicleInfo(id) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/${id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getVehicles() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  createVehicle(bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/vehicles`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateVehicle(id, bodyParms) {
    return axios
      .put(`${config["apiUrl"]}/fleet/vehicles/${id}`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getAllInsurances(id) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/${id}/insurance`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  createInsurance(id, bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/vehicles/${id}/insurance`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateInsurance(vehicleId, insuranceId, bodyParms) {
    return axios
      .put(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/insurance/${insuranceId}`,
        bodyParms,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addKm(id, bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/vehicles/${id}/kms`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  startUse(id, bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/vehicles/${id}/startUse`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  endUse(id, bodyParms) {
    return axios
      .patch(`${config["apiUrl"]}/fleet/vehicles/${id}/endUse`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  addDocument(id, bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/vehicles/${id}/document`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateDocument(vehicleId, documentId, bodyParms) {
    return axios
      .put(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/document/${documentId}`,
        bodyParms,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getDocument(vehicleId, documentId) {
    return axios
      .get(
        `${config["apiUrl"]}fleet/vehicles/${vehicleId}/document/${documentId}`,
        {
          headers: authHeader(),
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  deleteDocument(vehicleId, documentId) {
    return axios
      .delete(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/document/${documentId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  sendDocument(bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/sendDocs`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getVehicleUse(id) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/${id}/use`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addVehicleNote(vehicleId, bodyParms) {
    return axios
      .post(`${config["apiUrl"]}/fleet/vehicles/${vehicleId}/note`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  deleteVehicleNote(vehicleId, noteId) {
    return axios
      .delete(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/note/${noteId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getVehicleNotes(id) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/${id}/notes`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getBrands() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/brands`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getModels() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/models`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getCardsEntity() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/fleetCardsEntity`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getColors() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/colors`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getInsureres() {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/insureres`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPublicDocs(vehicleId) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/${vehicleId}/documents`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getFinesTpes() {
    return axios
      .get(`${config["apiUrl"]}/fleet/finesTypes`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  searchVehiclesByUserDate(userId, date) {
    return axios
      .get(
        `${config["apiUrl"]}/fleet/searchVehicles/user/${userId}/day/${date}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  searchCondutorByVehicleDate(vehicleId, date) {
    return axios
      .get(
        `${config["apiUrl"]}/fleet/searchConductor/vehicle/${vehicleId}/day/${date}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getVehicleFines(vehicleId) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicle/${vehicleId}/fines`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getFine(fineId) {
    return axios
      .get(`${config["apiUrl"]}/fleet/fine/${fineId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  createFine(bodyParms) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(`${config["apiUrl"]}/fleet/fine`, bodyParms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  updateFine(fineId, bodyParms) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(`${config["apiUrl"]}/fleet/fine/${fineId}`, bodyParms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getReports(vehicleId) {
    return axios
      .get(`${config["apiUrl"]}/fleet/vehicles/${vehicleId}/reports`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getReport(vehicleId, reportId) {
    return axios
      .get(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/report/${reportId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  createReport(vehicleId, formData) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/report`,
        formData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return error.response;
      });
  }

  updateReport(vehicleId, reportId, formData) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(
        `${config["apiUrl"]}/fleet/vehicles/${vehicleId}/report/${reportId}`,
        formData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return error.response;
      });
  }
}
export default new FleetService();
